import { Popover } from '@material-ui/core'
import styled, { css } from 'styled-components'
import { MAIN_BACKGROUND, PRIMARY_TEXT } from 'constants/colors'

export const SearchInputContainer = styled.div`
  .MuiTextField-root {
    .MuiInputBase-root {
      &:before,
      &:after {
        display: none;
      }
    }

    input {
      margin: 12px;
      font-size: 14px;
      line-height: 20px;
      padding: 10px 12px;
      background: ${MAIN_BACKGROUND};
      border-radius: 8px;
      border: 1px solid ${MAIN_BACKGROUND};
      color: ${PRIMARY_TEXT};

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
  }

  > div {
    width: 100%;
  }
`

export const StyledPopover = styled(Popover)<{ $noTransform?: boolean }>`
  font-size: 16px;
  line-height: 24px;

  .MuiPopover-paper {
    border-radius: 8px;
    font-size: 14px;
    padding: 4px 0;
    transform: translateY(37px) !important;
    min-width: 300px;
    color: ${PRIMARY_TEXT};
  }

  ${({ $noTransform }) =>
    $noTransform &&
    css`
      .MuiPopover-paper {
        transform: translateY(0px) !important;
      }
    `}
`
